import { todayInput } from "../../shared/utils/date";

export function toDailyPayload(values: Record<string, any>, tempKey?: string) {
  const paymentType = values.paymentType ?? "Cash";
  return {
    paymentEntryDate: values.paymentEntryDate?.format?.("YYYY-MM-DD") ?? todayInput(),
    paymentPaidDate: values.paymentPaidDate?.format?.("YYYY-MM-DD") ?? null,
    paidOfId: values.paidOfId,
    paymentOfId: values.paymentOfId,
    shortRemarkId: values.shortRemarkId,
    longRemarks: values.longRemarks,
    expenseMonthPayment: values.expenseMonthPayment,
    accountLedgerId: values.accountLedgerId,
    amount: values.amount,
    paymentType,
    bankId: paymentType === "Bank" ? values.bankId : null,
    bankAccountId: paymentType === "Bank" ? values.bankAccountId : null,
    paymentMode: paymentType === "Bank" ? values.paymentMode : "NA",
    paymentReference: paymentType === "Bank" ? values.paymentReference : null,
    paymentStatus: values.paymentStatus,
    transactionType: values.transactionType,
    tempKey
  };
}

export function toCashPayload(values: Record<string, any>) {
  return {
    dated: values.dated?.format?.("YYYY-MM-DD") ?? todayInput(),
    paidOf: values.paidOf,
    paymentOf: values.paymentOf,
    debit: Number(values.debit ?? 0),
    credit: Number(values.credit ?? 0),
    remarks: values.remarks
  };
}

export function toStatementPayload(values: Record<string, any>) {
  const debit = Number(values.debit ?? 0);
  const credit = Number(values.credit ?? 0);
  return {
    tranDate: values.tranDate?.format?.("YYYY-MM-DD") ?? todayInput(),
    chequeNo: values.chequeNo,
    particulars: values.particulars,
    debit,
    credit,
    narration: values.narration,
    type: debit > 0 ? "Debit" : credit > 0 ? "Credit" : values.type
  };
}
